import React, { useState, useEffect } from "react";

const Timer = (props) => {

    const [timeValues, setTimeValues] = useState({})
    const [isLoading, setIsLoading] = useState(true)

    var updatedDays, updatedHours, updatedMinutes, updatedSeconds;

    const getTimerValues = (timeDifference) => {
        console.log(timeDifference)
        let delta = Math.abs(timeDifference);
        console.log(delta)
        updatedDays = Math.floor(delta / 86400);
        delta -= updatedDays * 86400;
        console.log(updatedDays)
        updatedHours = Math.floor(delta / 3600) % 24;
        delta -= updatedHours * 3600;
        console.log(updatedHours)
        updatedMinutes = Math.floor(delta / 60) % 60;
        delta -= updatedMinutes * 60;
        console.log(updatedMinutes)
        updatedSeconds = delta % 60;
        console.log(updatedSeconds)

        return {
            days: updatedDays,
            hours: updatedHours,
            minutes: updatedMinutes,
            seconds: updatedSeconds
        }
    }

    const run = () => {
        if (updatedHours === 0) {
            if (updatedDays > 0) {
                updatedDays--;
                updatedHours = 24;
            }
        }
        if (updatedMinutes === 0) {
            if (updatedHours > 0) {
                updatedHours--;
                updatedMinutes = 59;
            }
        }
        if (updatedSeconds === 0) {
            if (updatedMinutes > 0) {
                updatedMinutes--;
                updatedSeconds = 60;
            }
        }
        if (updatedSeconds > 0) {
            updatedSeconds--;
        }
        return setTimeValues({ days: updatedDays, hours: updatedHours, minutes: updatedMinutes, seconds: updatedSeconds });
    };
    const start = () => {
        run();
        setInterval(run, 1000);
    }

    useEffect(() => {
        const getTimeValues = () => {
            setIsLoading(true)
            console.log(props.timeDifference)
            setTimeValues(getTimerValues(props.timeDifference))
            setIsLoading(false)
        }

        getTimeValues()
        start()

    }, [])

    const renderTimer = () => {
        if (isLoading === true) {
            return (
                <>
                    <div className="timer-txt">
                        <span>00</span>
                        <span>00</span>
                        <span>00</span>
                        <span>00</span>
                    </div>
                </>
            )
        } else {
            return (<div className="timer-txt">
                <span>{timeValues.days < 10 ? "0" + timeValues.days : timeValues.days}</span>
                <span>{timeValues.hours < 10 ? "0" + timeValues.hours : timeValues.hours}</span>
                <span>{timeValues.minutes < 10 ? "0" + timeValues.minutes : timeValues.minutes}</span>
                <span>{timeValues.seconds < 10 ? "0" + timeValues.seconds : timeValues.seconds}</span>
            </div>)
        }
    }
    return (
        <>
            {renderTimer()}
        </>
    )

}

export default Timer;